import About from "./components/About";
import Navbar from "./components/Navbar";
import TextForm from "./components/TextForm";
import Alert from "./components/Alert";
import React, { useState } from "react";
import { BrowserRouter as Router, Switch, Route} from "react-router-dom";

function App() {
  const [mode, setMode] = useState("light");
  const [theme, setTheme] = useState("off")
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 2000);
  };
  const toggleMode = () => {
    let darkModeSwitch = document.getElementById("darkModeSwitch");
    if (darkModeSwitch.checked) {
      setMode("dark");
      document.body.style.backgroundColor = "#141633";
      showAlert("Dark mode has been enabled", "success");
      setTheme("on");
    } else {
      setMode("light");
      setTheme("off");
      document.body.style.backgroundColor = "#ffffff";
      showAlert("Light mode has been enabled", "success");
    }
  };
  const themer = () => {
    document.body.style.backgroundColor = "#220202";
    setMode("dark");
    setTheme("on");
  };
  const themeg = () => {
    setMode("dark");
    setTheme("on");
    document.body.style.backgroundColor = "#0a312d";
  };





  
  return (
    <>
      <Router>
        <Navbar
          title="TextUtils"
          mode={mode}
          toggleMode={toggleMode}
          themer={themer}
          themeg={themeg}
        />
        <Alert alert={alert} />
        <Switch>
          <Route exact path="/about">
            <About theme={theme} />
          </Route>
          <Route exact path="/">
            <TextForm
              heading="Enter your text to analyze below"
              mode={mode}
              showAlert={showAlert}
            />
          </Route>
        </Switch>
      </Router>
    </>
  );
}

export default App;
